import {
  SPOR_TOTO_SLIP_TOGGLE,
  SPOR_TOTO_SLIP_RESET,
  SET_SPOR_TOTO_SLIP_DATA
} from 'Store/constants';

const initialState = {
  data: [],
  isOpen: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SPOR_TOTO_SLIP_TOGGLE:
      return { ...state, isOpen: !state.isOpen };
    case SET_SPOR_TOTO_SLIP_DATA:
      return { ...state, data: action.payload };
    case SPOR_TOTO_SLIP_RESET:
      return initialState;
    default:
      return state;
  }
};
